import { AnaColumn } from "../forms-template.service";

export const ElencoFIRPerBlocco: AnaColumn[] = [


  {
    itemType: "group", caption: 'Blocchi Virtuali', class: '', colCount: "1", data: [


      {
        type: 'campo', dataField: "seriale", colVisible: true, dataType: "", caption: "Seriale", hideOnEdit: true,
        colWidth: '200',
      },
      {
        type: 'campo', dataField: "nomeCognomeRichiesta", colVisible: true, dataType: "", caption: "Vidimazione richiesta da", hideOnEdit: true,
        colWidth: '300',
      },
      {
        type: 'campoData', dataField: "dataRichiesta", colVisible: true, dataType: "date", caption: "In data", hideOnEdit: true,
        format: "dd/MM/yyyy", colWidth: '180',
      },

      {
        type: 'campo', dataField: "stato",
        colVisible: true, dataType: "string", caption: "Stato", hideOnEdit: true,
        labelPosition: 'left',
        colWidth: '50',
        showInColumnChooser: true,
        editorType: 'dxSelectBox',
        allowFiltering: true,    
        lista: {
          dataSource: '',
          displayExpr: 'descrizione',
          valueExpr: 'id',
          static: true,

          items: [
            // { id: 9, descrizione: 'IN ELABORAZIONE' },
            { id: 1, descrizione: 'LIBERO' },
            { id: 2, descrizione: 'USATO' },
            // { id: 3, descrizione: 'ANNULLATO' }

          ]
        }

      },

      {
        type: 'button',
        dataType: "",
        caption: "",
        colWidth: '50',
        colVisible: false,
        allowEditing: false,
        button: {
          icon: 'mdi mdi-check-network-outline',
          text: 'Verifica',
          name: 'verificaFir',
          hint: 'Verifica lo stato di un Fir di qualsiasi origine e ne restituisce i dettagli',
          event: 'verificaFir',
          disabled: true,
        }
      },
      {
        type: 'button',
        dataType: "",
        caption: "",
        colWidth: '50',
        allowEditing: false,
        button: {
          icon: 'mdi mdi-eraser-variant',
          text: 'liberaFir',
          name: 'liberaFir',
          hint: 'libera fir già usato',
          event: 'liberaFir',

        }
      },
      {
        type: 'button',
        dataType: "",
        caption: "",
        colWidth: '50',
        allowEditing: false,
        colVisible: false,
        button: {
          icon: 'mdi mdi-check-network-outline',
          text: 'annullaFir',
          name: 'annullaFir',
          hint: 'Annulla fir usato',
          event: 'annullaFir',
          disabled: true,
        }
      },
    ]
  }
]